export default function formatSalary(
  value: number | string | undefined
): string {
  if (value == null || value === 0) {
    return "";
  }
  if (!Number(value)) {
    return "R$ " + value.toString();
  }

  const formattedValue = Number(value).toLocaleString("pt-BR", {
    style: "currency",
    currency: "BRL",
  });
  return formattedValue.replace(/\s/, " ");
}
